import { Message, MessageSeverity } from '@app/components/Messages/types';
import {
  getErrorCopyFromCode,
  userErrorMessages,
} from '@app/pages/cart/errorDict';
import {
  UpdateLineItemAPIError,
  UpdateLineItemErrorCodes,
} from '@app/types/monolith/types';
import { IntlShape, MessageDescriptor } from '@redbubble/next/intl';

export const getUpdateLineItemErrorMessage = (
  error: UpdateLineItemAPIError['error'],
  intl: IntlShape
) => {
  const inlineErrors: string[] = [];
  const generalErrors: Message[] = [];

  let errorStr: MessageDescriptor;

  try {
    errorStr = getErrorCopyFromCode({ code: error.error_code });
  } catch {
    errorStr = userErrorMessages.lineItemUnhandledUpdateError;
  }

  const userMessage = intl.formatMessage(errorStr, error.error_params);

  if (error.error_code === UpdateLineItemErrorCodes.QuantityInvalid) {
    inlineErrors.push(userMessage);
  } else {
    generalErrors.push({
      severity: MessageSeverity.Error,
      text: userMessage,
    });
  }

  return { inlineErrors, generalErrors };
};
